import { Redirect, Router } from "@reach/router";
import { User } from "./utils/helpers/types";
import NotFound from "./pages/not-found";
import "./styles/globals.scss";
import { RouteGuard, getDefaultLink } from "./utils/helpers/role-helpers";
import PortMapping from "./pages/port-mapping";
import IssuerConfig from "./pages/issuer-config";
import Wallet from "./pages/wallet";

const getRoutes: (user: User | null) => JSX.Element = user => {
  const defaultLink = getDefaultLink(user);

  return (
    <Router>
      {user && <Redirect from="/" to={defaultLink} noThrow />}
      <Redirect from="/spa/virtual-card-portlet" to={defaultLink} noThrow />

      <NotFound default />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["VCP_ADMIN"]}
        component={IssuerConfig}
        path="/issuer-config"
      />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["VCP_ADMIN"]}
        component={PortMapping}
        path="/port-mapping"
      />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["VCP_ADMIN"]}
        component={Wallet}
        path="/wallet"
      />
    </Router>
  );
};

export default getRoutes;
